module.exports = __webpack_public_path__ + "img/home_gmap_lg.17726838.png";